module.exports = __webpack_public_path__ + "static/media/maxico city.82d08452.png";